import AttendeeAction from './attendeeAction';
import Attendee from '../../../models/attendeeModel';
import Order from '../../order/models/orderModel';
import RefundOrder from '../../../pages/order/actions/rotateBarcode';
import RefundPostAction from '../post-action/refundPostAction';
import { fetcher } from '@weezevent/weezjs-core';
import RefundAdditionalContent from './additionalContent/refund';

export default class Refund extends AttendeeAction {
    static NAME = 'refund';
    static POST_ACTION_COMPONENT = RefundPostAction;
    static ADDITIONNAL_CONTENT_MODAL = RefundAdditionalContent;
    static ASYNCHRONOUS_LIMIT_MIN = 50;

    constructor(props) {
        super(props);
        this.refund_type = 'all';
    }

    setRefundType(type) {
        this.refund_type = type;
    }

    static condition(attendee) {
        const refundRequest = attendee.refund_requests ? attendee.refund_requests.filter(r => !r.removed) : null;
        const hasRefunded = !refundRequest || refundRequest.length === 0 ? false : true;
        return (
            (attendee.order.attendee_count === attendee.order.attendees_deleted_count || attendee.order.internal_transaction) &&
            attendee.order.origin === 'weez_web' &&
            Number(attendee.order.price_ticket) > 0 &&
            !hasRefunded &&
            super.payment_plan_condition(attendee)
        );
    }

    static is_attendee_valid({ attendee }) {
        return !attendee.removed || !attendee.scanned;
    }

    static is_available({ event }) {
        return !['over', 'closed'].includes(event.status) && !event.removed;
    }

    static is_disabled({ items, event }) {
        return event.status !== 'closed' && event.removed === null && !items.some(i => this.condition(i));
    }

    run({ orders = null, attendees = null }) {
        if (orders) {
            const to_refund = orders.filter(o => RefundOrder.condition(o));
            this.filtered_orders = to_refund;
        }
        this.filtered_attendees = attendees || this.filtered_items;
        if (this.filtered_attendees >= this.constructor.ASYNCHRONOUS_LIMIT_MIN) {
            this.total_attendees = this.filtered_attendees.length;
            this.mode = this.constructor.TYPE;
            return Promise.resolve(true);
        }

        let options = {
            dry_run: true,
            refund_charges: true
        };

        if (this.refund_type !== 'all') {
            options[this.refund_type] = true;
        }

        return fetcher
            .post(`/ticket/organizations/${this.organization.id}/events/${this.event.pk}/refund`, {
                data: {
                    options: options,
                    ...(this.filtered_attendees && !orders && { attendee_ids: this.filtered_attendees.map(attendee => attendee.id) }),
                    ...(this.filtered_orders && { order_ids: this.filtered_orders.map(order => order.pk) })
                }
            })
            .then(response => response.json())
            .then(json => {
                this.total_amount = json.amount;
                if (orders) {
                    this.total_orders = orders.length;
                    this.mode = RefundOrder.TYPE;
                    return true;
                }
                this.mode = this.constructor.TYPE;
                this.total_attendees = this.filtered_attendees.length;
                return true;
            });
    }

    onActionDone() {
        if (!this.async) {
            this.sync();
        }
        this.onClose();
    }

    get post_action() {
        return true;
    }

    get withToastRun() {
        return false;
    }

    runPostAction({ items, mode, delete_all }) {
        if (mode === 'orders') {
            return Order.perform_action(RefundOrder.NAME, items, { organization: this.organization, event: this.event, delete_all, refund_type: this.refund_type });
        }

        return Attendee.perform_action(
            this.constructor.NAME,
            items,
            { organization: this.organization, event: this.event, delete_all, refund_type: this.refund_type },
            this.isAsync(items)
        );
    }
}
